import { Ingredient, Supplement } from './Nutrition.model';

export function getBookmarkedItems(supplement: Supplement[]): Supplement[] {
  return supplement.map((product: Supplement) => {
    // Create a deep copy of the entire product
    const productCopy: Supplement = JSON.parse(JSON.stringify(product));

    // Filter parent ingredients
    if (productCopy.formula.ingredients) {
      productCopy.formula.ingredients = productCopy.formula.ingredients.filter(
        (item: Ingredient) => item.is_bookmarked === true,
      );
    }

    // Filter and remove empty blends
    if (productCopy.formula.blends) {
      productCopy.formula.blends = productCopy.formula.blends
        .map((blend) => {
          const filteredBlend = { ...blend };
          filteredBlend.ingredients = blend.ingredients.filter(
            (childItem: Ingredient) => childItem.is_bookmarked === true,
          );
          return filteredBlend;
        })
        .filter((blend) => blend.ingredients.length > 0);
    }

    return productCopy;
  });
}
